<p-toast></p-toast>
<div class="bank-details-container">
  <p-card styleClass="p-card-shadow">
    <h5 class="mt-0">{{'BANK_DETAILS'| translate}}</h5>
    <div class="card dashboardTable">
      <p-toolbar styleClass="mb-4">
        <ng-template pTemplate="left">
          <button pButton icon="pi pi-fw pi-plus" label="{{'ADD_BANK_DETAILS'| translate}}" (click)="openNew()" class="p-button-success" ></button>
          <!-- <button pButton pRipple  icon="pi pi-trash" class="ml-4 p-button-danger" (click)="deleteSelectedProducts()" [disabled]="!selectedBankAccounts || !selectedBankAccounts.length"></button> -->
        </ng-template>
        <ng-template pTemplate="right">
          <!-- <p-fileUpload accept=".jpeg,.pdf,.jpg" mode="basic" [maxFileSize]="5000000" label="Import" chooseLabel="Import" class="mr-2 inline-block"></p-fileUpload> -->
          <button (click)="menu.toggle($event)" pButton pRipple label="{{'EXPORT'| translate}}" icon="pi pi-upload" class="p-button-help"></button>
          <p-menu #menu [popup]="true" [model]="items"></p-menu>
        </ng-template>

      </p-toolbar>

      <p-table #dt [value]="bankAccountList" [rows]="10" [paginator]="true"
        [globalFilterFields]="['accountHolderName','bankName','accountNumber','ifscCode']" responsiveLayout="scroll"
        [(selection)]="selectedBankAccounts" [rowHover]="true" dataKey="id"
        currentPageReportTemplate="{{'SHOWING'| translate}} {first} {{'TO'| translate}} {last} {{'OF'| translate}} {totalRecords} {{'ENTRIES'| translate}}" [showCurrentPageReport]="true" [loading]="loading">
        <ng-template pTemplate="caption" >
          <div class="flex align-items-center justify-content-between">
            <h5 class="m-0">{{'MANAGE_BANK_ACCOUNTS'| translate}}</h5>
            <span class="p-input-icon-left">
              <i class="pi pi-search"></i>
              <input pInputText type="text" (input)="dt.filterGlobal($any($event.target).value, 'contains')" placeholder="{{'SEARCH'| translate}}..." />
            </span>
          </div>
        </ng-template>
        <ng-template pTemplate="header">
          <tr>
            <!-- <th style="width: 3rem">
              <p-tableHeaderCheckbox></p-tableHeaderCheckbox>

            </th> -->
            <th pSortableColumn="accountHolderName">{{'ACCOUNT_HOLDERS_NAME'| translate}}
              <p-columnFilter type="text" field="accountHolderName" display="menu"></p-columnFilter>
              <p-sortIcon field="accountHolderName"></p-sortIcon>
            </th>
            <th pSortableColumn="bankName">{{'BANK_NAME'| translate}}
              <p-columnFilter type="text" field="bankName" display="menu"></p-columnFilter>
              <p-sortIcon field="bankName"></p-sortIcon>
            </th>
            <th pSortableColumn="accountNumber">{{'ACCOUNT_NO'| translate}}
              <p-columnFilter type="text" field="accountNumber" display="menu"></p-columnFilter>
              <p-sortIcon field="accountNumber"></p-sortIcon>
            </th>
            <th pSortableColumn="ifscCode">{{'IFSC_CODE'| translate}}
              <p-columnFilter type="text" field="ifscCode" display="menu"></p-columnFilter>
              <p-sortIcon field="ifscCode"></p-sortIcon>
            </th>
            <th pSortableColumn="Active">{{'ACTIVE'| translate}}
              <p-columnFilter type="text" field="Active" display="menu"></p-columnFilter>
              <p-sortIcon field="Active"></p-sortIcon>
            </th>
            <th></th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-product>
          <tr>
            <!-- <td>
              <p-tableCheckbox [value]="product"></p-tableCheckbox>
            </td> -->
            <td>{{product.accountHolderName}}</td>
            <td>{{product.bankName}}</td>
            <td>{{product.accountNumber}}</td>
            <td> {{product.ifscCode}}
            <td> {{product.Active}}
              <!-- <p-rating [ngModel]="product.rating" [readonly]="true" [cancel]="false"></p-rating> -->
            </td>
            <!-- <td><span
                [class]="'product-badge status-' + (product.inventoryStatus ? product.inventoryStatus.toLowerCase() : '')">{{product.inventoryStatus}}</span>
            </td> -->
            <td>
              <!-- <button pButton pRipple icon="pi pi-pencil" class="p-button-rounded p-button-success mr-2"
                (click)="editProduct(product)"></button> -->
                <div *ngIf="product.IsDelete == 1" >
                  <button pButton pRipple icon="pi pi-trash" class="p-button-rounded p-button-warning"
                    (click)="deleteProduct(product)"></button>
                </div>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="summary">
          <div class="flex align-items-center justify-content-between">
            {{'IN_TOTAL_THERE_ARE'| translate}} {{bankAccountList ? bankAccountList.length : 0 }} {{'BANK_DETAILS_ADDED'| translate}}.
          </div>
        </ng-template>
      </p-table>
    </div>
  </p-card>
</div>


<p-dialog [(visible)]="addBankDialog" [style]="{width: '550px'}" header="Add Bank Details" [modal]="true" [baseZIndex]="-100"
  styleClass="p-fluid">
  <ng-template pTemplate="content">
    <!-- <div class="field">
      <label for="name">Farmers Name</label>
      <input type="text" pInputText id="name" [(ngModel)]="bankAccount.farmerName" required autofocus />
      <small class="p-error" *ngIf="submitted && !bankAccount.farmerName">Name is required.</small>
    </div> -->
    <div class="field">
      <label for="name">{{'ACCOUNT_HOLDER_NAME'| translate}}</label>
      <input type="text" pInputText id="name" [(ngModel)]="bankAccount.accountHolderName" required autofocus />
      <small class="p-error" *ngIf="submitted && !bankAccount.accountHolderName">{{'NAME_IS_REQUIRED'| translate}}.</small>
    </div>
    <div class="field">
      <label for="description">{{'ACCOUNT_NUMBER'| translate}}</label>
      <input type="number" type="number" (keydown.arrowup)="(false)" (keydown.arrowdown)="(false)" pInputText id="name" [(ngModel)]="bankAccount.accountNumber" required autofocus />
      <small class="p-error" *ngIf="submitted && !bankAccount.accountNumber">{{'NAME_IS_REQUIRED'| translate}}.</small>

      <!-- <textarea id="description" pInputTextarea [(ngModel)]="product.description" required rows="3" cols="20"></textarea> -->
    </div>
    <div class="formgrid grid">
      <div class="field col">
        <label for="inventoryStatus">{{'BANK_NAME'| translate}}</label>
        <!-- <input type="text" pInputText id="name" [(ngModel)]="bankAccount.bankName" required autofocus /> -->
        <!-- <p-dropdown [options]="bankList" [(ngModel)]="bankAccount.bankName" optionLabel="Bank_NAME" optionValue="BANK_ID"
        placeholder="select name of bank"></p-dropdown> -->

        <p-autoComplete [(ngModel)]="bankAccount.bankName" placeholder="Select Bank Name" id="dd" [dropdown]="true" [multiple]="false" appendTo="body"
        [suggestions]="filteredBankList" (completeMethod)="filterBank($event)" field="Bank_NAME" value="BANK_ID" ></p-autoComplete>


        <!-- <p-dropdown [(ngModel)]="product.inventoryStatus" inputId="inventoryStatus" [options]="statuses" placeholder="Select">
              <ng-template let-option pTemplate="item">
                  <span [class]="'product-badge status-' + option.value">{{option.label}}</span>
              </ng-template>]
          </p-dropdown> -->
      </div>
      <div class="field col">
        <label for="inventoryStatus">{{'IFSC_CODE'| translate}}</label>
        <input type="text" pInputText id="name" [(ngModel)]="bankAccount.ifscCode" required autofocus />
      </div>
    </div>
    <div class="field">
      <label for="inventoryStatus">{{'PASSBOOK_PHOTO_UPLOAD'| translate}}</label>
      <div class="flex">


        <p-fileUpload accept=".jpeg,.pdf,.jpg" [customUpload]="true" #farmerBankPassBookUpload (uploadHandler)="onUpload($event, 'passbookImage', farmerBankPassBookUpload)" name="myfile[]" mode="basic" [maxFileSize]="5000000" chooseLabel="{{'BROWSE'| translate}}" [auto]="true" >
        </p-fileUpload>
        <p-image *ngIf="bankAccount.image" [src]="bankAccount.image" alt="Image" width="60" class="ml-2 p-button-rounded p-button-success" iconPos="left"></p-image>

        <!-- <div class="image-background ml-2">

          <img [src] ="bankAccount.image" alt="passbook photo" *ngIf="bankAccount.image"  class="ml-2 p-button-rounded p-button-success" iconPos="left">
        </div>

        <button *ngIf="bankAccount.image" pButton type="button" icon="pi pi-check" class="ml-2 p-button-rounded p-button-success" iconPos="left"></button> -->
      </div>
      <div *ngIf="submitted && !bankAccount.image" class="invalid-feedback">
        <div *ngIf="!bankAccount.image">{{'FARMERS_PHOTO_IS_REQUIRED'| translate}}</div>
      </div>
      <!-- <textarea id="description" pInputTextarea [(ngModel)]="product.description" required rows="3" cols="20"></textarea> -->
    </div>
    <!-- <div class="formgrid grid">
      <div class="field col flex">
        <label for="inventoryStatus" class="mr-5">Is Active</label>
        <p-inputSwitch [(ngModel)]="checked"></p-inputSwitch>
      </div>
    </div> -->

    <!-- <div class="field">
      <label class="mb-3">Category</label>
      <div class="formgrid grid">
        <div class="field-radiobutton col-6">
          <p-radioButton id="category1" name="category" value="Accessories" [(ngModel)]="product.category">
          </p-radioButton>
          <label for="category1">Accessories</label>
        </div>
        <div class="field-radiobutton col-6">
          <p-radioButton id="category2" name="category" value="Clothing" [(ngModel)]="product.category"></p-radioButton>
          <label for="category2">Clothing</label>
        </div>
        <div class="field-radiobutton col-6">
          <p-radioButton id="category3" name="category" value="Electronics" [(ngModel)]="product.category">
          </p-radioButton>
          <label for="category3">Electronics</label>
        </div>
        <div class="field-radiobutton col-6">
          <p-radioButton id="category4" name="category" value="Fitness" [(ngModel)]="product.category"></p-radioButton>
          <label for="category4">Fitness</label>
        </div>
      </div>
    </div>

    <div class="formgrid grid">
      <div class="field col">
        <label for="price">Price</label>
        <p-inputNumber id="price" [(ngModel)]="product.price" mode="currency" currency="USD" locale="en-US">
        </p-inputNumber>
      </div>
      <div class="field col">
        <label for="quantity">Quantity</label>
        <p-inputNumber id="quantity" [(ngModel)]="product.quantity"></p-inputNumber>
      </div>
    </div> -->
  </ng-template>

  <ng-template pTemplate="footer">
    <button pButton pRipple label="{{'CANCEL' | translate}}" icon="pi pi-times" class="p-button-text" (click)="hideDialog()"></button>
    <button pButton pRipple label="{{'SAVE'| translate}}" icon="pi pi-check" class="p-button-text" (click)="saveProduct()"></button>
  </ng-template>
</p-dialog>

<p-confirmDialog [style]="{width: '400px'}"></p-confirmDialog>
